import { useCallback, useEffect, useState } from 'react';

import { useElementSize } from '../helpers/useElementSize';
import { useWindowSize } from '../helpers/useWindowSize';

export const useScrollInfo = () => {
	const [elementRef, { width }] = useElementSize();
	const [scrollWidth, setScrollWidth] = useState(width);
	const [scrollLeft, setScrollLeft] = useState(0);
	const { dimensions, size } = useWindowSize();

	const refreshScrollInformation = useCallback(() => {
		const { current } = elementRef;

		if (!current) return;

		setScrollLeft(current.scrollLeft);
		setScrollWidth(current.scrollWidth);
	}, [elementRef]);

	useEffect(() => {
		const { current } = elementRef;

		if (!current) return;

		refreshScrollInformation();

		current.addEventListener('scroll', refreshScrollInformation);

		return () => {
			current.removeEventListener('scroll', refreshScrollInformation);
		};
	}, [refreshScrollInformation, dimensions]);

	const onScrollLeft = useCallback(() => {
		const { current } = elementRef;

		if (!current) return;

		current.scrollBy({
			behavior: 'smooth',
			left: -200
		});
	}, [elementRef]);

	const onScrollRight = useCallback(() => {
		const { current } = elementRef;

		if (!current) return;

		current.scrollBy({
			behavior: 'smooth',
			left: 200
		});
	}, [elementRef]);

	return {
		elementRef,
		onScrollLeft,
		onScrollRight,
		scrollLeft,
		scrollWidth,
		size,
		width
	};
};
